import React, { useEffect } from 'react';
import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import { SnackbarProvider, useSnackbar } from 'notistack';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AuthContextProvider from 'AuthContext';
import AppRoutes from 'AppRoutes';
import { semiTheme } from 'util/layout';

import './App.scss';

const App: React.FunctionComponent = () => {
  useEffect(() => {
    document.body.classList.add('theme-semi');
  }, []);

  function SnackbarCloseButton({ snackbarKey }: any) {
    const { closeSnackbar } = useSnackbar();

    return (
      <IconButton sx={{ color: 'white' }} onClick={() => closeSnackbar(snackbarKey)}>
        <CloseIcon />
      </IconButton>
    );
  }

  return (
    <StyledEngineProvider injectFirst={true}>
      <ThemeProvider theme={semiTheme}>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          action={(snackbarKey) => <SnackbarCloseButton snackbarKey={snackbarKey} />}
        >
          <AuthContextProvider>
            <AppRoutes />
          </AuthContextProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
